import React from "react";
import { cn } from "../lib/helpers";
import Button from "./button";
import ImageG from "./image-g";

import * as styles from "../styles/components/cta.module.css";

interface ImageAsset {
  asset?: {
    _id?: string;
  };
  alt?: string;
}

interface Image {
  desktop?: ImageAsset;
  mobile?: ImageAsset;
}

interface ButtonType {
  text?: string;
  url?: string;
  blank?: boolean;
}

interface CtaProps {
  title?: string;
  subtitle?: string;
  button?: ButtonType;
  image?: Image;
  imageOverlay?: string;
}

const Cta: React.FC<CtaProps> = ({ 
  title,
  subtitle,
  button,
  image,
  imageOverlay
}) => {
  // Now safely child elements
  const { desktop: desktopImage, mobile: mobileImage } = image || {};

  if (!title || !desktopImage?.asset) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={cn(styles.image, imageOverlay && "overlay-"+imageOverlay)}>
        <ImageG node={desktopImage} nodeM={mobileImage} />
      </div>

      <div className={styles.text}>
        <div className={styles.wrap}>
          {subtitle && (<div className={styles.subtitle}>{subtitle}</div>)}
          <h5 className={styles.title}>{title}</h5>
          <Button node={button} theme="white" />
        </div>
      </div>
    </div>
  );
}

export default Cta;
